var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-leadtags"},_vm._l((_vm.leadTags),function(tag){return _c('v-chip',{key:`tag-${tag}`,staticClass:"mr-1 mb-1",attrs:{"label":"","dark":"","color":_vm.tagColor(tag),"small":!_vm.small,"x-small":_vm.small},domProps:{"textContent":_vm._s(_vm.leadTag(tag)?.name)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }